import type {CustomerHostChrome} from '@fitro/customer-features/host-contract'

export const HostTopBanner: CustomerHostChrome['HostTopBanner'] = () => null
